// being used

import React, { useState } from "react";
import { Formik, Form } from "formik";
import {
  Paper,
  Typography,
  Divider,
  ToggleButtonGroup,
  ToggleButton,
  Button,
  TextField,
} from "@mui/material";

import { makeStyles } from "@material-ui/core/styles";

// QuantumHub Library
import { Timer } from "@thequantumhub/timer";
// import Timer from "../Shared/Timer";

import { validationSchema } from "../../../utils/ppeValidationSchema";

import { createRecordPPE } from "../../../service/endpoint-manager";
import { FormControl, MenuItem, Select } from "@material-ui/core";

import styles from "../../../styles.module.css";
import styled from "@emotion/styled";
import {
  MAX_DROPDOWN_HEIGHT,
  PPE_HISTORY,
} from "../../../types/micellinous-constants";
import { addHistoryItemToList } from "../../../utils/helperFunctions";
import { useSnackbar } from "notistack";
import ButtonTextLoading from "../Shared/ButtonTextLoading";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  formPaper: {
    // padding: theme.spacing(2),
    // margin: theme.spacing(1),
    // maxWidth: "60%",
  },
  toggleContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    margin: theme.spacing(1),
  },
  toggleButtonGroup: {
    // marginTop: theme.spacing(1),
  },
}));

const MuiToggleButton = styled(ToggleButton)(() => ({
  minWidth: "80px !important",
  height: "34px",
  borderRadius: "0px !important",
  // border: "2px solid white",
  // padding: "10px",
  color: "#415970",
  "&:first-child": {
    borderTopLeftRadius: "6px !important",
    borderBottomLeftRadius: "6px !important",
  },
  "&:last-child": {
    borderTopRightRadius: "6px !important",
    borderBottomRightRadius: "6px !important",
  },

  "&:hover": {
    backgroundColor: "#FFD7EB",
  },
  "&.Mui-selected, &.Mui-selected:hover": {
    backgroundColor: "#F516AA",
    color: "white",
  },
}));
const ToggleButtonGroupField = ({
  name,
  value,
  options,
  setFieldValue,
  outcomeExistsPath,
}) => {
  const classes = useStyles();
  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      onChange={(e, value) => {
        if (outcomeExistsPath) {
          setFieldValue(outcomeExistsPath, value === "yes" ? true : false);
        }
        if (value) {
          setFieldValue(name, value);
        } else {
          setFieldValue(name, "");
        }
      }}
      aria-label={name}
      className={clsx(styles.toggleButtonGroup, "togglePickerPPE")}
    >
      {options.map((option) => (
        <MuiToggleButton
          key={option.value}
          value={option.value}
          aria-label={option.label}
          className={styles.toggleButton}
        >
          {option.label}
        </MuiToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

const PaperSection = ({ title, children }) => {
  const classes = useStyles();
  return (
    <Paper className={classes.formPaper}>
      {title && <Typography variant="h6">{title}</Typography>}
      {children}
    </Paper>
  );
};

const PPEFormComponent = ({
  selectedFacility,
  selectedUnit,
  nurse,
  resetCounter,
  onFormReset,
  allPayloads,
  setAllPayloads,
}) => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [timerValues, setTimerValues] = useState([0, 0, 0]);
  const [showForm, setShowForm] = useState(false);

  const calculateTotalQuestions = (formData) => {
    let totalQuestions = 0;
    let notObservedQuestions = 0;

    formData.formQuestions.forEach((step) => {
      step.questions.forEach((question) => {
        totalQuestions += 1;
        if (question.response.value === "notObserved") {
          notObservedQuestions += 1;
        }
      });
    });
    return totalQuestions - notObservedQuestions;
  };

  const initialValues = {
    nurse: nurse,
    selectedFacility: selectedFacility ? selectedFacility.name : "",
    selectedUnit: selectedUnit ? selectedUnit.id : "",
    precautions: "",
    healthCareWorker: "Physician",
    totalQuestions: 0,
    nonCompliantAnswers: 0,
    nonCompliantWashRub: 0,
    compliantAnswers: 0,
    auditStrictCompliance: false,
    isTimerRunning: false,
    formQuestions: [
      {
        stepTitle: "Precautions/Setup",
        questions: [
          {
            question: "Precaution signage visible before entering the room",
            response: {
              value: "",
            },
          },
          {
            question: "PPE supplies available immediately outside room",
            response: {
              value: "",
            },
          },
        ],
      },
      {
        stepTitle: "Donning PPE (Putting on PPE)",
        questions: [
          {
            question:
              "Hand hygiene is performed immediately prior to putting on PPE",
            response: {
              value: "",
              outcomeExists: false,
              outcome: {
                type: "",
                value: 0,
              },
            },
          },
          {
            question:
              "New single use or clean reusable PPE is put on prior to entering the room",
            response: {
              value: "",
            },
          },
          {
            question: "Put on Gown",
            response: {
              value: "",
            },
          },
          {
            question: "Put on Mask or N95 Respirator",
            response: {
              value: "",
            },
          },
          {
            question: "Put on Eye Protection",
            response: {
              value: "",
            },
          },
          {
            question: "Put on Gloves",
            response: {
              value: "",
            },
          },
        ],
      },
      {
        stepTitle: "Use of PPE",
        questions: [
          {
            question: "PPE is only worn inside the isolation room/space",
            response: {
              value: "",
            },
          },
          {
            question:
              "Worker did not adjust mask, protective clothing or unprotected areas of body/clothing",
            response: {
              value: "",
            },
          },
        ],
      },
      {
        stepTitle: "Doffing PPE (Taking off PPE)",
        questions: [
          {
            question: "Removing Gloves",
            response: {
              value: "",
            },
          },
          {
            question: "Remove Gown",
            response: {
              value: "",
            },
          },
          {
            question: "Hand hygiene is performed",
            response: {
              value: "",
              outcomeExists: false,
              outcome: {
                type: "",
                value: 0,
              },
            },
          },
          {
            question: "Remove Eyewear/Face Shield",
            response: {
              value: "",
            },
          },
          {
            question: "Remove Mask/N95 Respirator",
            response: {
              value: "",
            },
          },
          {
            question: "Hand hygiene is performed",
            response: {
              value: "",
              outcomeExists: false,
              outcome: {
                type: "",
                value: 0,
              },
            },
          },
        ],
      },
    ],
    comments: "",
  };
  initialValues.totalQuestions = calculateTotalQuestions(initialValues);

  const toggleOptions = [
    { value: "yes", label: "Yes" },
    { value: "no", label: "No" },
    { value: "notObserved", label: "Not Observed" },
  ];

  const handleTimerStop = (finalValue, index) => {
    setTimerValues((prevTimerValues) => {
      const updatedValues = [...prevTimerValues];
      updatedValues[index] = finalValue;
      return updatedValues;
    });
  };

  const handleStartClick = () => {
    setShowForm(!showForm);
  };

  const handleFormSubmit = (values, { setSubmitting, resetForm }) => {
    const totalQuestions = calculateTotalQuestions(values);
    let nonCompliantAnswers = 0;
    let nonCompliantWashRub = 0;

    values.formQuestions.forEach((step) => {
      step.questions.forEach((question) => {
        if (question.response.value === "no") {
          nonCompliantAnswers += 1;
        }

        if (question.response.outcomeExists) {
          const outcomeType = question.response.outcome.type;
          const outcomeValue = parseInt(question.response.outcome.value, 10);

          if (
            (outcomeType === "wash" && outcomeValue < 20) ||
            (outcomeType === "rub" && outcomeValue < 15)
          ) {
            nonCompliantWashRub += 1;
          }
        }
      });
    });
    const compliantAnswers =
      totalQuestions - (nonCompliantAnswers + nonCompliantWashRub);

    const auditStrictCompliance = compliantAnswers === totalQuestions;

    const requestData = {
      nurse: values.nurse,
      facility: values.selectedFacility,
      unit: values.selectedUnit,
      formQuestions: values.formQuestions,
      healthCareWorker: values.healthCareWorker,
      precautions: values.precautions,
      comments: values.comments,
      totalQuestions: totalQuestions,
      nonCompliantAnswers: nonCompliantAnswers,
      nonCompliantWashRub: nonCompliantWashRub,
      compliantAnswers: compliantAnswers,
      auditStrictCompliance: auditStrictCompliance,
    };

    createRecordPPE(requestData)
      .then((response) => {
        enqueueSnackbar(`${response?.data?.message}`, {
          variant: "success",
        });
        // addHistoryItemToList(PPE_HISTORY, requestData);
        setSubmitting(false);
        resetForm();
        setShowForm(false);
        const initialTimerValues = [0, 0, 0];
        setTimerValues(initialTimerValues);
      })
      .catch((error) => {
        enqueueSnackbar(`${error}`, {
          variant: "error",
        });
        console.error("Error submitting form:", error);
        setSubmitting(false);
      });
  };

  const resetFormFields = () => {
    const initialTimerValues = [0, 0, 0];

    setTimerValues(initialTimerValues);

    if (onFormReset) {
      onFormReset();
    }
  };

  const handleCancel = (values, { resetForm }) => {
    resetForm();
    setShowForm(false);
    const initialTimerValues = [0, 0, 0];
    setTimerValues(initialTimerValues);
  };

  const validHealthcareWorkerOptions = [
    "",
    "Physician",
    "Registered Staff",
    "PSW",
    "Student",
    "Dietary",
    "Social worker",
    "Pastoral care",
    "Lab/X-ray/blood collection",
    "OT/PT/PTA (Therapy Staff)",
    "Housekeeping",
    "Laundry staff",
    "Volunteer",
    "Programs",
    "Essential Caregiver",
    "Private caregiver",
    "One-to-one worker",
    "Dental services",
    "BSO",
    "Optometry",
    "Hair Stylist",
    "Nurse Practitioner",
    "General visitor",
    "Footcare nurse",
    "Admin",
    "Security",
    "Maintenance",
  ];

  const errorText = (error) => {
    try {
      return (
        <div
          style={{
            color: "red",
            fontSize: "0.7rem",
            marginTop: "5px",
            textAlign: "left",
            visibility: error ? "visible" : "hidden",
          }}
        >
          {error}
        </div>
      );
    } catch (e) {
      return "";
    }
  };
  const hasErrors = (errors) => Object.keys(errors).length > 0;
  return (
    <>
      {!showForm && (
        <Button
          variant="contained"
          color="primary"
          onClick={handleStartClick}
          className={styles.primaryButton}
        >
          Start
        </Button>
      )}

      {showForm && (
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleFormSubmit}
          validateOnChange={true}
          // validateOnBlur={true}
        >
          {({
            values,
            setFieldValue,
            handleChange,
            isSubmitting,
            resetForm,
            errors,
            touched,
          }) => (
            <Form className={styles.formFlex}>
              <FormControl variant="outlined" fullWidth margin="normal">
                <div className={styles.titleFlex}>
                  <Typography
                    variant="body"
                    className={styles.handHygieneTitleBold}
                  >
                    Precautions
                  </Typography>
                </div>
                <Select
                  name="precautions"
                  value={values.precautions}
                  onChange={(e) => {
                    setFieldValue("precautions", e.target.value);
                  }}
                >
                  <MenuItem value="Contact">Contact</MenuItem>
                  <MenuItem value="Droplet">Droplet</MenuItem>
                  <MenuItem value="Airborne">Airborne</MenuItem>
                  <MenuItem value="Droplet Contact Plus">
                    Droplet Contact Plus
                  </MenuItem>
                </Select>
                {errorText(errors?.precautions)}
              </FormControl>
              <FormControl variant="outlined" fullWidth margin="normal">
                <div className={styles.titleFlex}>
                  <Typography
                    variant="body"
                    className={styles.handHygieneTitleBold}
                  >
                    Health Care
                  </Typography>
                  <div style={{ margin: "4px" }} />
                  <Typography
                    variant="body"
                    className={styles.handHygieneTitleSimple}
                  >
                    Worker
                  </Typography>
                </div>
                <Select
                  name={`healthCareWorker`}
                  value={
                    validHealthcareWorkerOptions.includes(
                      values.healthCareWorker
                    )
                      ? values.healthCareWorker
                      : ""
                  }
                  MenuProps={{
                    style: {
                      maxHeight: MAX_DROPDOWN_HEIGHT,
                    },
                  }}
                  onChange={(e) => {
                    const selectedValue = e.target.value;
                    if (validHealthcareWorkerOptions.includes(selectedValue)) {
                      setFieldValue(`healthCareWorker`, selectedValue);
                    } else {
                      setFieldValue(`healthCareWorker`, "");
                    }
                  }}
                >
                  <MenuItem value="Physician">Physician</MenuItem>
                  <MenuItem value="Registered Staff">Registered Staff</MenuItem>
                  <MenuItem value="PSW">PSW</MenuItem>
                  <MenuItem value="Student">Student</MenuItem>
                  <MenuItem value="Dietary">Dietary</MenuItem>
                  <MenuItem value="Social worker">Social worker</MenuItem>
                  <MenuItem value="Pastoral care">Pastoral care</MenuItem>
                  <MenuItem value="Lab/X-ray/blood collection">
                    Lab/X-ray/blood collection
                  </MenuItem>
                  <MenuItem value="OT/PT/PTA (Therapy Staff)">
                    OT/PT/PTA (Therapy Staff)
                  </MenuItem>
                  <MenuItem value="Housekeeping">Housekeeping</MenuItem>
                  <MenuItem value="Laundry staff">Laundry staff</MenuItem>
                  <MenuItem value="Volunteer">Volunteer</MenuItem>
                  <MenuItem value="Programs">Programs</MenuItem>
                  <MenuItem value="Essential Caregiver">
                    Essential Caregiver
                  </MenuItem>
                  <MenuItem value="Private caregiver">
                    Private caregiver
                  </MenuItem>
                  <MenuItem value="One-to-one worker">
                    One-to-one worker
                  </MenuItem>
                  <MenuItem value="Dental services">Dental services</MenuItem>
                  <MenuItem value="BSO">BSO</MenuItem>
                  <MenuItem value="Optometry">Optometry</MenuItem>
                  <MenuItem value="Hair Stylist">Hair Stylist</MenuItem>
                  <MenuItem value="Nurse Practitioner">
                    Nurse Practitioner
                  </MenuItem>
                  <MenuItem value="General visitor">General visitor</MenuItem>
                  <MenuItem value="Footcare nurse">Footcare nurse</MenuItem>
                  <MenuItem value="Admin">Admin</MenuItem>
                  <MenuItem value="Security">Security</MenuItem>
                  <MenuItem value="Maintenance">Maintenance</MenuItem>
                </Select>
                {errorText(errors?.healthCareWorker)}
              </FormControl>
              <Paper className={styles.formPaper}>
                <div className={styles.observationPointSectionMain}>
                  <Typography variant="h6" className={styles.momentTitle}>
                    1. Precautions / Steps
                  </Typography>
                  <div className={classes.toggleContainer}>
                    <Typography
                      variant="body2"
                      className={styles.observationPointMargin}
                    >
                      Precaution signage visible before entering the room
                    </Typography>
                    <ToggleButtonGroupField
                      name="formQuestions[0].questions[0].response.value"
                      value={
                        values.formQuestions[0].questions[0].response.value
                      }
                      options={toggleOptions}
                      setFieldValue={setFieldValue}
                      className={styles.observationPointMargin}
                    />
                    {errorText(
                      errors &&
                        errors?.formQuestions &&
                        errors?.formQuestions[0]?.questions &&
                        errors?.formQuestions[0].questions[0]?.response?.value
                    )}
                  </div>
                </div>
                <Divider />
                <div className={styles.observationPointSection}>
                  <div className={classes.toggleContainer}>
                    <Typography
                      variant="body2"
                      className={styles.observationPointMargin}
                    >
                      PPE supplies available immediately outside room
                    </Typography>
                    <ToggleButtonGroupField
                      name="formQuestions[0].questions[1].response.value"
                      value={
                        values.formQuestions[0].questions[1].response.value
                      }
                      options={toggleOptions}
                      setFieldValue={setFieldValue}
                      className={styles.observationPointMargin}
                    />
                    {errorText(
                      errors &&
                        errors?.formQuestions &&
                        errors?.formQuestions[0]?.questions &&
                        errors?.formQuestions[0]?.questions[1]?.response?.value
                    )}
                  </div>
                </div>
              </Paper>
              <Paper className={styles.formPaper}>
                <div className={styles.observationPointSectionMain}>
                  <Typography variant="h6" className={styles.momentTitle}>
                    2. Donning PPE (Putting on PPE)
                  </Typography>
                  <div className={classes.toggleContainer}>
                    <Typography
                      variant="body2"
                      className={styles.observationPointMargin}
                    >
                      Hand hygiene is performed immediately prior to putting on
                      PPE
                    </Typography>
                    <div
                      // className={styles.observationPointMargin}
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <ToggleButtonGroupField
                        name="formQuestions[1].questions[0].response.value"
                        value={
                          values.formQuestions[1].questions[0].response.value
                        }
                        options={toggleOptions}
                        setFieldValue={setFieldValue}
                        outcomeExistsPath="formQuestions[1].questions[0].response.outcomeExists"
                      />

                      {values.formQuestions[1].questions[0].response.value ===
                        "yes" && (
                        <div style={{ marginLeft: "20px", display: "flex" }}>
                          <ToggleButtonGroupField
                            name="formQuestions[1].questions[0].response.outcome.type"
                            value={
                              values.formQuestions[1].questions[0].response
                                .outcome.type
                            }
                            options={[
                              { value: "wash", label: "Wash" },
                              { value: "rub", label: "Rub" },
                            ]}
                            setFieldValue={setFieldValue}
                          />
                          {values.formQuestions[1].questions[0].response.outcome
                            .type && (
                            <Timer
                              timer={timerValues[0]}
                              onTimerChange={(finalValue) =>
                                handleTimerStop(finalValue, 0)
                              }
                              setFieldValue={setFieldValue}
                              name="formQuestions[1].questions[0].response.outcome.value"
                              isRunningName="isTimerRunning"
                            />
                          )}
                        </div>
                      )}
                    </div>
                    {errorText(
                      errors &&
                        errors?.formQuestions &&
                        errors?.formQuestions[1]?.questions &&
                        errors?.formQuestions[1]?.questions[0]?.response?.value
                    )}
                    {errorText(
                      errors &&
                        errors?.formQuestions &&
                        errors?.formQuestions[1]?.questions &&
                        errors?.formQuestions[1]?.questions[0]?.response
                          ?.outcome?.type
                    )}
                  </div>
                </div>
                <Divider />
                <div className={styles.observationPointSection}>
                  <div className={classes.toggleContainer}>
                    <Typography
                      variant="body2"
                      className={styles.observationPointMargin}
                    >
                      New single use or clean reusable PPE is put on prior to
                      entering the room
                    </Typography>
                    <ToggleButtonGroupField
                      name="formQuestions[1].questions[1].response.value"
                      value={
                        values.formQuestions[1].questions[1].response.value
                      }
                      options={toggleOptions}
                      setFieldValue={setFieldValue}
                      className={styles.observationPointMargin}
                    />
                    {errorText(
                      errors &&
                        errors?.formQuestions &&
                        errors?.formQuestions[1]?.questions &&
                        errors?.formQuestions[1]?.questions[1]?.response?.value
                    )}
                  </div>
                </div>
                <Divider />
                <div className={styles.observationPointSection}>
                  <div className={classes.toggleContainer}>
                    <Typography
                      variant="body2"
                      className={styles.observationPointMargin}
                    >
                      Put on Gown
                    </Typography>
                    <ul className={styles.observationPointTextAlign}>
                      <li>
                        Gown securely tied at the neck first then the waist
                      </li>
                    </ul>
                    <ToggleButtonGroupField
                      name="formQuestions[1].questions[2].response.value"
                      value={
                        values.formQuestions[1].questions[2].response.value
                      }
                      options={toggleOptions}
                      setFieldValue={setFieldValue}
                      className={styles.observationPointMargin}
                    />
                    {errorText(
                      errors &&
                        errors?.formQuestions &&
                        errors?.formQuestions[1]?.questions &&
                        errors?.formQuestions[1]?.questions[2]?.response?.value
                    )}
                  </div>
                </div>

                <Divider />
                <div className={styles.observationPointSection}>
                  <div className={classes.toggleContainer}>
                    <Typography
                      variant="body2"
                      className={styles.observationPointMargin}
                    >
                      Put on Mask or N95 Respirator (if applicable)
                    </Typography>
                    <ul className={styles.observationPointTextAlign}>
                      <li>Place mask over nose and under chin</li>
                      <li>Secure ties, loops, or straps</li>
                      <li>Mold metal piece to your nose bridge</li>
                      <li>For respirators, perform a seal-check</li>
                    </ul>
                    <ToggleButtonGroupField
                      name="formQuestions[1].questions[3].response.value"
                      value={
                        values.formQuestions[1].questions[3].response.value
                      }
                      options={toggleOptions}
                      setFieldValue={setFieldValue}
                      className={styles.observationPointMargin}
                    />
                    {errorText(
                      errors &&
                        errors?.formQuestions &&
                        errors?.formQuestions[1]?.questions &&
                        errors?.formQuestions[1]?.questions[3]?.response?.value
                    )}
                  </div>
                </div>

                <Divider />
                <div className={styles.observationPointSection}>
                  <div className={classes.toggleContainer}>
                    <Typography
                      variant="body2"
                      className={styles.observationPointMargin}
                    >
                      Put on Eye Protection (if applicable)
                    </Typography>
                    <ul className={styles.observationPointTextAlign}>
                      <li>
                        Put on eye protection if visor is not attached to mask
                        and adjust to fit
                      </li>
                      <li>Face shield should fit over brow</li>
                    </ul>
                    <ToggleButtonGroupField
                      name="formQuestions[1].questions[4].response.value"
                      value={
                        values.formQuestions[1].questions[4].response.value
                      }
                      options={toggleOptions}
                      setFieldValue={setFieldValue}
                      className={styles.observationPointMargin}
                    />
                    {errorText(
                      errors &&
                        errors?.formQuestions &&
                        errors?.formQuestions[1]?.questions &&
                        errors?.formQuestions[1]?.questions[4]?.response?.value
                    )}
                  </div>
                </div>

                <Divider />
                <div className={styles.observationPointSection}>
                  <div className={classes.toggleContainer}>
                    <Typography
                      variant="body2"
                      className={styles.observationPointMargin}
                    >
                      Put on Gloves
                    </Typography>
                    <ul className={styles.observationPointTextAlign}>
                      <li>
                        Put on gloves, taking care not to tear or puncture
                      </li>
                      <li>
                        If a gown is worn the gloves fit over the gown's cuff
                      </li>
                    </ul>
                    <ToggleButtonGroupField
                      name="formQuestions[1].questions[5].response.value"
                      value={
                        values.formQuestions[1].questions[5].response.value
                      }
                      options={toggleOptions}
                      setFieldValue={setFieldValue}
                      className={styles.observationPointMargin}
                    />
                    {errorText(
                      errors &&
                        errors?.formQuestions &&
                        errors?.formQuestions[1]?.questions &&
                        errors?.formQuestions[1]?.questions[5]?.response?.value
                    )}
                  </div>
                </div>
              </Paper>
              <Paper className={styles.formPaper}>
                <div className={styles.observationPointSectionMain}>
                  <Typography variant="h6" className={styles.momentTitle}>
                    3. Use of PPE
                  </Typography>
                  <div className={classes.toggleContainer}>
                    <Typography
                      variant="body2"
                      className={styles.observationPointMargin}
                    >
                      PPE is only worn inside the isolation room/space
                    </Typography>
                    <ToggleButtonGroupField
                      name="formQuestions[2].questions[0].response.value"
                      value={
                        values.formQuestions[2].questions[0].response.value
                      }
                      options={toggleOptions}
                      setFieldValue={setFieldValue}
                      className={styles.observationPointMargin}
                    />
                    {errorText(
                      errors &&
                        errors?.formQuestions &&
                        errors?.formQuestions[2]?.questions &&
                        errors?.formQuestions[2]?.questions[0]?.response?.value
                    )}
                  </div>
                </div>
                <Divider />
                <div className={styles.observationPointSection}>
                  <div className={classes.toggleContainer}>
                    <Typography
                      variant="body2"
                      className={styles.observationPointMargin}
                    >
                      Worker did not adjust mask, protective clothing or
                      unprotected areas of body/clothing
                    </Typography>
                    <ToggleButtonGroupField
                      name="formQuestions[2].questions[1].response.value"
                      value={
                        values.formQuestions[2].questions[1].response.value
                      }
                      options={toggleOptions}
                      setFieldValue={setFieldValue}
                      className={styles.observationPointMargin}
                    />
                    {errorText(
                      errors &&
                        errors?.formQuestions &&
                        errors?.formQuestions[2]?.questions &&
                        errors?.formQuestions[2]?.questions[1]?.response?.value
                    )}
                  </div>
                </div>
              </Paper>
              <Paper className={styles.formPaper}>
                <div className={styles.observationPointSectionMain}>
                  <Typography variant="h6" className={styles.momentTitle}>
                    4. Doffing PPE (Taking off PPE)
                  </Typography>
                  <div className={classes.toggleContainer}>
                    <Typography
                      variant="body2"
                      className={styles.observationPointMargin}
                    >
                      Removing Gloves
                    </Typography>
                    <ul className={styles.observationPointTextAlign}>
                      <li>
                        Grasp outside edge near the wrist and peel away rolling
                        the glove inside-out
                      </li>
                      <li>Reach under the second glove and peel away</li>
                      <li>Discard immediately into waste receptacle</li>
                    </ul>
                    <ToggleButtonGroupField
                      name="formQuestions[3].questions[0].response.value"
                      value={
                        values.formQuestions[3].questions[0].response.value
                      }
                      options={toggleOptions}
                      setFieldValue={setFieldValue}
                      className={styles.observationPointMargin}
                    />
                    {errorText(
                      errors &&
                        errors?.formQuestions &&
                        errors?.formQuestions[3]?.questions &&
                        errors?.formQuestions[3]?.questions[0]?.response?.value
                    )}
                  </div>
                </div>
                <Divider />
                <div className={styles.observationPointSection}>
                  <div className={classes.toggleContainer}>
                    <Typography
                      variant="body2"
                      className={styles.observationPointMargin}
                    >
                      Remove Gown
                    </Typography>
                    <ul className={styles.observationPointTextAlign}>
                      <li>Unfasten ties/fastener</li>
                      <li>
                        Pull away from neck and shoulders, touching inside of
                        gown only
                      </li>
                      <li>Turn gown inside out</li>
                      <li>
                        Fold or roll into bundle and discard immediately waste
                        receptacle
                      </li>
                    </ul>
                    <ToggleButtonGroupField
                      name="formQuestions[3].questions[1].response.value"
                      value={
                        values.formQuestions[3].questions[1].response.value
                      }
                      options={toggleOptions}
                      setFieldValue={setFieldValue}
                      className={styles.observationPointMargin}
                    />
                    {errorText(
                      errors &&
                        errors?.formQuestions &&
                        errors?.formQuestions[3]?.questions &&
                        errors?.formQuestions[3]?.questions[1]?.response?.value
                    )}
                  </div>
                </div>
                <Divider />
                <div className={styles.observationPointSection}>
                  <div className={classes.toggleContainer}>
                    <Typography
                      variant="body2"
                      className={styles.observationPointMargin}
                    >
                      Hand hygiene is performed
                    </Typography>
                    <div
                      // className={styles.observationPointMargin}
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <ToggleButtonGroupField
                        name="formQuestions[3].questions[2].response.value"
                        value={
                          values.formQuestions[3].questions[2].response.value
                        }
                        options={toggleOptions}
                        setFieldValue={setFieldValue}
                        outcomeExistsPath="formQuestions[3].questions[2].response.outcomeExists"
                      />

                      {values.formQuestions[3].questions[2].response.value ===
                        "yes" && (
                        <div style={{ marginLeft: "20px", display: "flex" }}>
                          <ToggleButtonGroupField
                            name="formQuestions[3].questions[2].response.outcome.type"
                            value={
                              values.formQuestions[3].questions[2].response
                                .outcome.type
                            }
                            options={[
                              { value: "wash", label: "Wash" },
                              { value: "rub", label: "Rub" },
                            ]}
                            setFieldValue={setFieldValue}
                          />
                          {values.formQuestions[3].questions[2].response.outcome
                            .type && (
                            <Timer
                              timer={timerValues[1]}
                              onTimerChange={(finalValue) =>
                                handleTimerStop(finalValue, 1)
                              }
                              setFieldValue={setFieldValue}
                              name="formQuestions[3].questions[2].response.outcome.value"
                              isRunningName="isTimerRunning"
                            />
                          )}
                        </div>
                      )}
                    </div>
                    {errorText(
                      errors &&
                        errors?.formQuestions &&
                        errors?.formQuestions[3]?.questions &&
                        errors?.formQuestions[3]?.questions[2]?.response?.value
                    )}
                    {errorText(
                      errors &&
                        errors?.formQuestions &&
                        errors?.formQuestions[3]?.questions &&
                        errors?.formQuestions[3]?.questions[2]?.response
                          ?.outcome?.type
                    )}
                  </div>
                </div>
                <Divider />
                <div className={styles.observationPointSection}>
                  <div className={classes.toggleContainer}>
                    <Typography
                      variant="body2"
                      className={styles.observationPointMargin}
                    >
                      Remove Eyewear/Face Shield
                    </Typography>
                    <ul className={styles.observationPointTextAlign}>
                      <li>
                        Remove eye protection by handling ear loops, sides or
                        back only
                      </li>
                      <li>
                        Discard into waste receptacle or into appropriate
                        container
                      </li>
                    </ul>
                    <ToggleButtonGroupField
                      name="formQuestions[3].questions[3].response.value"
                      value={
                        values.formQuestions[3].questions[3].response.value
                      }
                      options={toggleOptions}
                      setFieldValue={setFieldValue}
                      className={styles.observationPointMargin}
                    />
                    {errorText(
                      errors &&
                        errors?.formQuestions &&
                        errors?.formQuestions[3]?.questions &&
                        errors?.formQuestions[3]?.questions[3]?.response?.value
                    )}
                  </div>
                </div>
                <Divider />
                <div className={styles.observationPointSection}>
                  <div className={classes.toggleContainer}>
                    <Typography
                      variant="body2"
                      className={styles.observationPointMargin}
                    >
                      Remove Mask/N95 Respirator
                    </Typography>
                    <ul className={styles.observationPointTextAlign}>
                      <li>
                        Remove mask / respirator by handling ties / ear loops /
                        straps only
                      </li>
                      <li>
                        Untie bottom tie then top tie, or grasp straps or ear
                        loops
                      </li>
                      <li>
                        Pull forward off the head, allowing mask / respirator to
                        fall away from the face
                      </li>
                      <li>Discard immediately into waste receptacle</li>
                    </ul>
                    <ToggleButtonGroupField
                      name="formQuestions[3].questions[4].response.value"
                      value={
                        values.formQuestions[3].questions[4].response.value
                      }
                      options={toggleOptions}
                      setFieldValue={setFieldValue}
                      className={styles.observationPointMargin}
                    />
                    {errorText(
                      errors &&
                        errors?.formQuestions &&
                        errors?.formQuestions[3]?.questions &&
                        errors?.formQuestions[3]?.questions[4]?.response?.value
                    )}
                  </div>
                </div>
                <Divider />
                <div className={styles.observationPointSection}>
                  <div className={classes.toggleContainer}>
                    <Typography
                      variant="body2"
                      className={styles.observationPointMargin}
                    >
                      Hand hygiene is performed
                    </Typography>
                    <div
                      // className={styles.observationPointMargin}
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <ToggleButtonGroupField
                        name="formQuestions[3].questions[5].response.value"
                        value={
                          values.formQuestions[3].questions[5].response.value
                        }
                        options={toggleOptions}
                        setFieldValue={setFieldValue}
                        outcomeExistsPath="formQuestions[3].questions[5].response.outcomeExists"
                      />

                      {values.formQuestions[3].questions[5].response.value ===
                        "yes" && (
                        <div style={{ marginLeft: "20px", display: "flex" }}>
                          <ToggleButtonGroupField
                            name="formQuestions[3].questions[5].response.outcome.type"
                            value={
                              values.formQuestions[3].questions[5].response
                                .outcome.type
                            }
                            options={[
                              { value: "wash", label: "Wash" },
                              { value: "rub", label: "Rub" },
                            ]}
                            setFieldValue={setFieldValue}
                          />

                          {values.formQuestions[3].questions[5].response.outcome
                            .type && (
                            <Timer
                              timer={timerValues[2]}
                              onTimerChange={(finalValue) =>
                                handleTimerStop(finalValue, 2)
                              }
                              setFieldValue={setFieldValue}
                              name="formQuestions[3].questions[5].response.outcome.value"
                              isRunningName="isTimerRunning"
                            />
                          )}
                        </div>
                      )}
                    </div>
                    {errorText(
                      errors &&
                        errors?.formQuestions &&
                        errors?.formQuestions[3]?.questions &&
                        errors?.formQuestions[3]?.questions[5]?.response?.value
                    )}
                    {errorText(
                      errors &&
                        errors?.formQuestions &&
                        errors?.formQuestions[3]?.questions &&
                        errors?.formQuestions[3]?.questions[5]?.response
                          ?.outcome?.type
                    )}
                  </div>
                </div>
                <Divider />
              </Paper>
              <TextField
                name="comments"
                label="Comments"
                multiline
                rows={4}
                variant="outlined"
                fullWidth
                margin="normal"
                value={values.comments}
                onChange={handleChange}
                error={touched.comments && Boolean(errors.comments)}
                helperText={touched.comments ? errors.comments : ""}
              />
              {errorText(errors?.isTimerRunning)}

              <div className={styles.buttonContainer}>
                <Button
                  type="reset"
                  variant="outline"
                  className={styles.redButton}
                  onClick={() => {
                    handleStartClick();
                    resetForm();
                  }}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={isSubmitting || hasErrors(errors && errors)}
                  className={styles.primaryButton}
                >
                  {/* Submit */}
                  <ButtonTextLoading
                    isSubmitting={isSubmitting}
                    body={"SUBMIT"}
                  />
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      )}
    </>
  );
};

export default PPEFormComponent;
